import { Role } from "@leap4/auth";

const baseBackendRoute = process.env.REACT_APP_BACKEND_BASE_URL + "";
export const BACKEND_SERVICE_NAME = "conversion-internal-backend";
export const logoutUrl = baseBackendRoute + "/app/logout";
export const requiredAuthRoles: Role[] = [Role.ADMIN];
export const meUrl = baseBackendRoute + "/app/me";
export const meMultiUrl = baseBackendRoute + "/app/me_multi"
export const setCookieUrl = baseBackendRoute + "/app/set-cookie";
export const reportingBaseUrl = baseBackendRoute + "/reporting"
export type OptionalDays = 1 | 7 | 28 | 30 | -1
export type DaysType = {
    [T: string]: { label: '-1' | '-7' | '-28' | '-30', value: OptionalDays }
}

export const DAYS: DaysType = {
    ONE: { label: '-1', value: 1 },
    SEVEN: { label: '-7', value: 7 },
    TWENTY_EIGHT: { label: '-28', value: 28 },
    FULL_MONTH_AGO: { label: '-30', value: 30 }
}

export const DATE_FORMAT = "YYYY-MM-DD"
